export const listQueryKeys = {
  artists: 'artists',
  artistsLightList: 'artist-light-list',
  tracks: 'tracks',
  tracksLightList: 'tracks-light-list',
  videos: 'videos',
  musicProductDigital: 'music-product-digital-list',
  thread: 'chats-list',
};
